export const DATE_TIME_FORMAT = 'MM/DD/YY, hh:mm A';
export const DATE_FORMAT = 'MMM DD';
